// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2P1EE","col":"styles_col__1zZn_"};